import { useCallback } from 'react'
import { useSnackbar } from '@ui/snackbar'
import { useBlockAction } from '@editorHooks'
import {
  RESULTS2_DESIGN_FORM_BLOCK_ACTION,
  UNSAVED_BEMESSUNG_NAV_MESSAGE,
  unsavedBemessungNavSnackbarOptions,
} from '../components/Results2DetailPane/constants'

/**
 * Guards navigation away from the Bemessung (design) form while it has unsaved changes.
 *
 * Returns a function that reports whether navigation is blocked: when it is, it shows the
 * "bitte speichern" snackbar and returns `true` (the caller should abort); otherwise `false`.
 * Call it right before changing the selection/tab/mode.
 *
 * For conditional guards, short-circuit the cheaper condition first so the snackbar only appears
 * when the guard actually applies, e.g. `if (targetGuid !== currentId && guard()) return`.
 */
const useDesignFormNavigationGuard = (): (() => boolean) => {
  const { enqueueSnackbar } = useSnackbar()
  const { isBlockedFn: isDesignFormBlockedFn } = useBlockAction(
    RESULTS2_DESIGN_FORM_BLOCK_ACTION,
    'subscriber',
  )

  return useCallback(() => {
    if (isDesignFormBlockedFn()) {
      enqueueSnackbar(UNSAVED_BEMESSUNG_NAV_MESSAGE, unsavedBemessungNavSnackbarOptions)
      return true
    }
    return false
  }, [isDesignFormBlockedFn, enqueueSnackbar])
}

export default useDesignFormNavigationGuard
